export default [
	{
		name: 'Print',
		availability: 'print'
	},
	{
		name: 'Online',
		availability: 'online'
	},
	{
		name: 'Print & Online',
		availability: 'print_online'
	}
]
